import { Newspaper, Download } from 'lucide-react';
import { MarketingLayout } from '../../layouts/MarketingLayout';

const releases = [
  {
    date: '2026-04-08',
    title: 'Keskedo opens public beta of the unified app ecosystem',
    excerpt: 'Members can now use a single biometric identity across dozens of independent applications.',
  },
  {
    date: '2026-01-19',
    title: 'Keskedo launches on-chain governance for ecosystem-wide proposals',
    excerpt: 'Members vote with verifiable cryptographic signatures, with the ledger fully open to inspection.',
  },
  {
    date: '2025-09-30',
    title: 'Keskedo achieves SOC 2 Type II certification',
    excerpt: 'Independent auditors verified Keskedo\'s controls across security, availability, and confidentiality.',
  },
];

const contacts = [
  { label: 'Press inquiries', value: 'press@keskedo.com' },
  { label: 'Partnerships', value: 'partnerships@keskedo.com' },
];

export const Press = () => {
  return (
    <MarketingLayout
      title="Press & news"
      subtitle="The latest announcements, milestones, and brand assets from the Keskedo team."
    >
      <section className="space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {contacts.map((c, i) => (
            <div key={i} className="p-6 bg-slate-50 rounded-2xl border border-slate-200 space-y-1">
              <p className="text-xs uppercase tracking-wider text-slate-500 font-bold">{c.label}</p>
              <p className="font-mono text-sm text-slate-900">{c.value}</p>
            </div>
          ))}
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-slate-900">Recent announcements</h2>
          <div className="space-y-4">
            {releases.map((r, i) => (
              <article key={i} className="p-6 bg-white border border-slate-200 rounded-2xl space-y-2">
                <div className="flex items-center gap-2 text-xs text-slate-400">
                  <Newspaper size={12} />
                  <time>{r.date}</time>
                </div>
                <h3 className="font-bold text-lg text-slate-900">{r.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{r.excerpt}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="p-8 bg-slate-900 text-white rounded-2xl flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="space-y-2">
            <h3 className="text-xl font-bold">Brand assets</h3>
            <p className="text-sm text-slate-300">Logos, wordmarks, and product screenshots in print-ready formats.</p>
          </div>
          <button className="inline-flex items-center gap-2 bg-white text-slate-900 px-5 py-3 rounded-lg font-bold text-sm hover:bg-slate-100">
            <Download size={16} /> Download press kit
          </button>
        </div>
      </section>
    </MarketingLayout>
  );
};
